import React from "react";
import { useContext } from "../../../../context";
import { SURVEY_TYPE } from "../../../../../../../../api/surveys/config";
import { Textbox } from "./Textbox";
import { YesNo } from "./YesNo";
import { SingleChoice } from "./SingleChoice";
import { MultipleChoice } from "./MultipleChoice";
import { Scale } from "./Scale";
import { File } from "./File";
import { BLOCK_FIELDS } from "../../../../config";

const blocksByType = {
  [SURVEY_TYPE.text]: <Textbox />,
  [SURVEY_TYPE.binary]: <YesNo />,
  [SURVEY_TYPE.singleChoice]: <SingleChoice />,
  [SURVEY_TYPE.multipleChoice]: <MultipleChoice />,
  [SURVEY_TYPE.scale]: <Scale />,
  [SURVEY_TYPE.file]: <File />,
};

export const Content = () => {
  const { blocks } = useContext();
  const block = blocks.getCurrent();
  return blocksByType[block[BLOCK_FIELDS.type]] || null;
};
